module.exports = __webpack_public_path__ + "static/media/mobBurger.30130751.svg";